import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CarDetailsService } from '../../car-details-service/car-details.service';
import { SectionHeaderModule } from '../../section-header/section-header.module';
import { UsedCarsModule } from '../../used-cars/used-cars.module';
import { FILTER_FACET } from '../../filter-service/filter.models';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-used-cars-list-query-spot',
    template: `
        <ng-container *ngIf="data && isReady">
            <app-section-header
                [headerTextPrimary]="data?.usedCarsHeaderText"
                [buttonLink]="data?.usedCarsHeaderLink">
            </app-section-header>

            <app-used-cars-list
                [query]="data.usedCarsQuery"
                [lastSlideText]="data.usedCarsLastSlideText"
                [lastSlideLink]="data.usedCarsLastSlideLink"
                [displayAmount]="data.usedCarsDisplayAmount"
                [isUsedCarRelated]="data.isUsedCarRelated"
                [layoutMode]="data.usedCarsLayoutMode"
                [currentVehicleId]="currentVehicleId">
            </app-used-cars-list>
        </ng-container>
    `
})
class UsedCarsListQuerySpotComponent implements OnInit, OnDestroy {

    @Input() data: Cms.UsedCarsListQuerySpot;

    currentVehicleId: number;
    isReady: boolean;

    private readonly unsubscribe = new Subject<void>();

    constructor(
        private readonly carDetailsService: CarDetailsService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {

        if (this.data?.isUsedCarRelated) {
            this.carDetailsService.getCurrentMakeAndModel()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((carData: any) => {
                if (carData) {
                    this.currentVehicleId = carData.id ?? undefined;
                    this.data.usedCarsQuery = `${FILTER_FACET.MAKE}=${carData?.make}&${FILTER_FACET.MODEL}=${carData?.model}`;
                    this.isReady = true;
                    this.cdr.markForCheck();
                }
            });
        } else {
            this.isReady = true;
            this.cdr.markForCheck();
        }
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}

@NgModule({
    declarations: [UsedCarsListQuerySpotComponent],
    imports: [
        CommonModule,
        SectionHeaderModule,
        UsedCarsModule,
    ]
})
class UsedCarsListQuerySpotModule {}

export const LazySpotComponent = UsedCarsListQuerySpotComponent;
